import { getMappedFeedbackTrackingName } from '@hotjar/webapp/features/Playbacks/utils/getMappedFeedbackTrackingName';
import { EventMarker } from '@hotjar/webapp/features/Playbacks/types';
import { Store } from '../../../store/player/types';
import { trackSidebarEventClick } from './trackSidebarEventClick';
import { jumpTo } from './jumpTo';

/**
 * Track sidebar event click and jump to event in timeline.
 */
export const onSidebarEventClick = (store: Store, item: EventMarker): void => {
  const { setTimelineJumpToTime } = store.getState();
  const name = item.name ?? '';

  setTimelineJumpToTime(performance.now());

  if (item?.name?.startsWith('feedback')) {
    // We make a copy to avoid modifying the original object
    item = { ...item };
    item.name = getMappedFeedbackTrackingName(item.name || '') || '';
  }

  trackSidebarEventClick(store, item.time, name, item.type);
  jumpTo(store, item.time);
};
